import castArray from 'lodash/castArray'
import first from 'lodash/first'
import join from 'lodash/join'
import { GetServerSideProps } from 'next'
import React from 'react'

import { LatestArticlesAndCollectionsBlock } from '@Components/CMS/Blocks/LatestArticlesAndCollectionsBlock'
import { CMSPage } from '@Components/CMS/Page'
import { Page, PageType } from '@Generated/graphql'
import { initializeApolloFromContext } from '@Globals/Apollo'
import { useBlockComponents } from '@Globals/CMS/useBlockComponents'
import { PageHOC } from '@Globals/Page/Client'
import { boostFromContext, handleRedirect, pageProps } from '@Globals/Page/Server'
import { PageProps } from '@Globals/Page/Types'
import { getSinglePost } from '@Queries/cms/SinglePost.query'

interface CSRProps extends PageProps {
  item: Page
}

type Params = {
  slug: string | string[]
}

export const getServerSideProps: GetServerSideProps<CSRProps, Params> = async (context) => {
  const { params } = context
  const slug = castArray(params?.slug || [])
  const id = first(slug)

  if (!slug || !id) {
    return {
      notFound: true,
    }
  }

  const apolloClient = initializeApolloFromContext(context)
  const post = await getSinglePost(apolloClient, PageType.Csr, `/csr/${join(params?.slug, '/')}`, undefined, boostFromContext(context))
  const { page } = post.data

  if (!page) {
    return {
      notFound: true,
    }
  }

  if (page?.type === 'redirect_permanent' || page?.type === 'redirect_temporary') {
    return handleRedirect(context, page.url, page.type)
  }

  return {
    props: {
      ...await pageProps(
        context,
        { type: 'csr', id },
        page,
        ['common', 'cms', 'footer', 'header', 'sidebar', 'validation', 'shipping'],
      ),
      item: page as Page,
    },
  }
}

const CSR = PageHOC<CSRProps>(({ item }) => {
  const components = useBlockComponents(item.blocks || [])

  return (
    <CMSPage>
      {components}
      <LatestArticlesAndCollectionsBlock />
    </CMSPage>
  )
})

export default CSR
